var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvolved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1730_7243)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1730_7243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.37207 0.105972H60.0545V59.9287H0.37207V0.105972Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1730_7243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0545 30.0172C60.0545 46.5369 46.6942 59.9286 30.2132 59.9286C13.7324 59.9286 0.37207 46.5369 0.37207 30.0172C0.37207 13.4976 13.7324 0.10585 30.2132 0.10585C46.6942 0.10585 60.0545 13.4976 60.0545 30.0172Z",
    fill: "#F52D30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1730_7243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4358 0.105057C46.9004 0.124173 60.2419 13.5088 60.2419 30.0167L60.2379 30.5113C59.9744 46.8029 46.7165 59.9281 30.4005 59.9281L29.907 59.9241C13.6539 59.6599 0.55957 46.3712 0.55957 30.0167L0.563568 29.5221C0.827087 13.2305 14.0846 0.105057 30.4005 0.105057H30.3653H30.4358Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1730_7243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7048 22.6671C19.57 21.8 20.7207 21.3226 21.9442 21.3226C23.1679 21.3226 24.3179 21.8 25.1838 22.6671L30.5836 28.0808L35.9846 22.6677V22.6671C36.8497 21.8 38.0004 21.3226 39.2231 21.3226C40.4469 21.3226 41.5976 21.8 42.4627 22.6677C44.2486 24.4577 44.2486 27.3702 42.4627 29.1605L30.5836 41.0667L18.7048 29.1607C16.919 27.3702 16.919 24.4577 18.7048 22.6671ZM50.9094 62.645H43.581L35.8156 73.0899H33.5969V46.3628L46.6107 33.3184C50.6839 29.2353 50.6839 22.5921 46.6107 18.5095C44.6381 16.5315 42.0141 15.442 39.2231 15.442C36.4332 15.442 33.81 16.5312 31.8367 18.5092L30.5836 19.7647L29.3317 18.5092C27.3583 16.5312 24.7343 15.442 21.9442 15.442C19.1535 15.442 16.5294 16.5315 14.5569 18.5092C10.4836 22.5921 10.4836 29.2353 14.5569 33.319L27.5127 46.3046V88.5227H33.5969V78.7676H36.572L43.6483 88.5227H51.0101L41.3449 75.3475L50.9094 62.645Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1730_7243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvolved);
export default __webpack_public_path__ + "static/media/involved.3fbf05ed5eb2567e807b25289916ceb2.svg";
export { ForwardRef as ReactComponent };